import API from '@/services/api'

// Actions
export const FETCH_LOCATIONS = 'fetchLocations'
export const FETCH_ALL_LOCATIONS = 'fetchAllLocations'
export const FETCH_LOCATION = 'fetchLocation'
export const CREATE_LOCATION = 'createLocation'
export const UPDATE_LOCATION = 'updateLocation'
export const DELETE_LOCATION = 'deleteLocation'

// Mutations
export const STORE_SET_LOCATIONS = 'storeSetLocations'
export const STORE_ADD_LOCATION = 'storeAddLocation'
export const STORE_UPDATE_LOCATION = 'storeUpdateLocation'
export const STORE_DELETE_LOCATION = 'storeDeleteLocation'

const state = {
	locations: [],
}

const getters = {
	locations (state) {
		return state.locations
	},
}

const actions = {
	[FETCH_LOCATIONS] (context, options) {
		return new Promise((resolve, reject) => {
			API.query('locations/' + options.inspection).then((response) => {
				context.commit(STORE_SET_LOCATIONS, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_ALL_LOCATIONS] (context, options) {
		return new Promise((resolve, reject) => {
			API.query('objects/' + options.property + '/locations').then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_LOCATION] (context, options) {
		return new Promise((resolve, reject) => {
			API.query('locations/' + options.inspection + '/' + options.location ).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[CREATE_LOCATION] (context, options) {
		return new Promise((resolve, reject) => {
			API.post('locations/' + options.inspection, options.data).then((response) => {
				context.commit(STORE_ADD_LOCATION, response.data);
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[UPDATE_LOCATION] (context, options) {
		return new Promise((resolve, reject) => {
			API.update('locations/' + options.inspection, options.location, options.changes).then((response) => {
				context.commit(STORE_UPDATE_LOCATION, response.data)
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[DELETE_LOCATION] (context, options) {
		return new Promise((resolve, reject) => {
			API.delete('locations/' + options.inspection + '/' + options.location ).then((response) => {
				context.commit(STORE_DELETE_LOCATION, options.location)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

const mutations = {
	[STORE_SET_LOCATIONS] (state, locations) {
		state.locations = locations
	},
	[STORE_ADD_LOCATION] (state, location) {
		state.locations.push(location)
	},
	[STORE_UPDATE_LOCATION] (state, location) {
		let locations = []

		state.locations.map((mapLocation) => {
			if (mapLocation.id === location.id) {
				mapLocation = location
			}

			locations.push(mapLocation)
		})

		state.locations = locations
	},
	[STORE_DELETE_LOCATION] (state, location) {
		state.locations.splice(state.locations.indexOf(location), 1)
	},
}

export default { state, getters, actions, mutations }